/**
 * Auto-assign colors based on positive/negative keywords
 */

const POSITIVE_KEYWORDS = [
  'yes', 'y', 'affirmative', 'positive', 'true', 
  'accept', 'approve', 'confirm', 'ok', 'okay', 
  'agree', 'correct', 'right'
];

const NEGATIVE_KEYWORDS = [
  'no', 'n', 'negative', 'false', 
  'reject', 'deny', 'decline', 'cancel', 
  'disagree', 'wrong', 'incorrect'
];

export const POSITIVE_COLOR = '#22c55e';
export const NEGATIVE_COLOR = '#ef4444';

/**
 * Get auto-assigned color based on option label
 */
export function getOptionColor(label, fallbackColor) {
  const labelLower = label?.toLowerCase?.() || '';
  if (POSITIVE_KEYWORDS.includes(labelLower)) return POSITIVE_COLOR;
  if (NEGATIVE_KEYWORDS.includes(labelLower)) return NEGATIVE_COLOR;
  return fallbackColor;
}

/**
 * Process decision options to auto-assign colors based on keywords
 */
export function processDecisionOptions(rawOptions) {
  const defaultOptions = [
    { id: 'yes', label: 'Yes', color: POSITIVE_COLOR },
    { id: 'no', label: 'No', color: NEGATIVE_COLOR },
  ];
  
  const options = rawOptions || defaultOptions;
  
  return options.map(option => {
    const autoColor = getOptionColor(option.label, option.color);
    return { ...option, color: autoColor };
  });
}

export default { getOptionColor, processDecisionOptions, POSITIVE_COLOR, NEGATIVE_COLOR };

